import { useQuery, useMutation, useQueryClient } from 'react-query';
import { apiClient } from '../services/apiClient';
import {
  PodTimetablesDataReadDTO,
  PodTimetablesDataCreateDTO,
  BatchPodTimetablesDataRequest,
} from '../generated/api-client';

export const usePodTimetablesData = () => {
  return useQuery<PodTimetablesDataReadDTO[]>('podTimetablesData', () =>
    apiClient.list_items_pod_timetables_data__get()
  );
};

export const usePodTimetablesDataById = (id: string) => {
  return useQuery<PodTimetablesDataReadDTO>(
    ['podTimetablesData', id],
    () => apiClient.get_item_pod_timetables_data__item_id__get(id),
    {
      enabled: !!id,
    }
  );
};

export const useCreatePodTimetablesData = () => {
  const queryClient = useQueryClient();

  return useMutation<PodTimetablesDataReadDTO, Error, PodTimetablesDataCreateDTO>(
    data => apiClient.create_item_pod_timetables_data__post(data),
    {
      onSuccess: () => {
        queryClient.invalidateQueries('podTimetablesData');
      },
    }
  );
};

export const useUpdatePodTimetablesData = () => {
  const queryClient = useQueryClient();

  return useMutation<
    PodTimetablesDataReadDTO,
    Error,
    { id: string; data: PodTimetablesDataCreateDTO }
  >(({ id, data }) => apiClient.update_item_pod_timetables_data__item_id__put(id, data), {
    onSuccess: () => {
      queryClient.invalidateQueries('podTimetablesData');
    },
  });
};

export const useDeletePodTimetablesData = () => {
  const queryClient = useQueryClient();

  return useMutation<any, Error, string>(
    id => apiClient.delete_item_pod_timetables_data__item_id__delete(id),
    {
      onSuccess: () => {
        queryClient.invalidateQueries('podTimetablesData');
      },
    }
  );
};

export const useBatchSavePodTimetablesData = () => {
  const queryClient = useQueryClient();

  return useMutation<any, Error, Array<PodTimetablesDataCreateDTO & { id?: string }>>(
    items => {
      // Converti i DTO in dict plain per il backend
      // Il datetime deve essere inviato senza timezone
      const itemsAsDict = items.map(item => {
        const dict: any = {};
        dict.value = item.value;
        // Il backend richiede sempre datetime (422 se mancante), anche negli update
        if (item.id) {
          dict.id = item.id;
        }
        {
          if (item.pod_timetable_id !== undefined) dict.pod_timetable_id = item.pod_timetable_id;
          if (item.datetime !== undefined) {
            // Formatta datetime senza timezone (YYYY-MM-DD HH:mm:ss)
            const date = new Date(item.datetime);
            const year = date.getFullYear();
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const day = String(date.getDate()).padStart(2, '0');
            const hours = String(date.getHours()).padStart(2, '0');
            const minutes = String(date.getMinutes()).padStart(2, '0');
            const seconds = String(date.getSeconds()).padStart(2, '0');
            dict.datetime = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
          }
        }
        return dict;
      });
      const request = { items: itemsAsDict } as BatchPodTimetablesDataRequest;
      return apiClient.batch_save_pod_timetables_data_batch_post(request);
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries('podTimetablesData');
      },
    }
  );
};
